import React, { useEffect, useState } from 'react';
import { CustomModal } from '../common';
import serch from '../../assets/images/Search_1.svg';
import cancel from '../../assets/images/greay-cancel-icon.svg';
import { Button, Dropdown, DropdownButton, Image } from 'react-bootstrap';
import { getCommonApi, getSearchApi } from './Api';
import { isArray } from 'lodash';
import { toast } from 'react-toastify';
import { MAX_LIMIT, START_PAGE } from '../../utils/Constant';

export default function SearchContent({
  showModal,
  onHide,
  selectedContent,
  isMultiselect = false,
  params = {},
}) {
  const [keyData, setKeyData] = useState([]);
  const [keyDataMatch, setKeyDataMatch] = useState([]);
  const [searchApiData, setSearchApiData] = useState([]);
  const [serchKey, setSerchKey] = useState('');
  const [contentType, setContentType] = useState('Videos');
  const [contentTypeData, setContentTypeData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // ✅ Fetch keywords + content types only once
  const fetchInitialData = async () => {
    try {
      const [resKeywords, resTypes] = await Promise.all([
        getCommonApi(`keyword?pageSize=${MAX_LIMIT}&pageNumber=${START_PAGE}`),
        getCommonApi('website/contentType/list', { params }),
      ]);

      if (resKeywords.status === 200 && resTypes.status === 200) {
        setKeyData(resKeywords.data.data.list || []);
        setContentTypeData(resTypes.data.data || []);
      } else {
        toast.error('Failed to fetch search metadata');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong while loading data');
    }
  };

  // ✅ Search content by keyword / type
  const handleSearchApiCalled = async () => {
    try {
      const queryParams = {
        ...params,
        pageNumber: START_PAGE,
        contentType,
      };
      if (serchKey.trim()) queryParams.searchValue = serchKey.trim();

      const res = await getSearchApi('content/search', { params: queryParams });
      if (res.status === 200) {
        setSearchApiData(res.data.data?.contents?.[0]?.list || []);
        setShowDropdown(false);
      } else {
        toast.error('Search failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error fetching search results');
    }
  };

  useEffect(() => {
    fetchInitialData();

    if (isArray(selectedContent) && selectedContent.length > 0) {
      setSelectedData(selectedContent);
    }
  }, []); // ✅ only once

  const handleChange = (e) => {
    const value = e.target.value;
    setSerchKey(value);

    if (value.trim()) {
      const matches = keyData.filter((item) =>
        item.keyword.toLowerCase().startsWith(value.toLowerCase())
      );
      setKeyDataMatch(matches);
      setShowDropdown(true);
    } else {
      setKeyDataMatch([]);
      setShowDropdown(false);
    }
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchApiCalled();
    }
  };

  const addData = (data) => {
    if (isMultiselect) {
      setSelectedData((prev) => [...prev, data]);
    } else {
      setSelectedData([data]);
    }
  };

  const removeDataHandler = (id) => {
    setSelectedData((prev) => prev.filter((item) => item.uuid !== id));
  };

  return (
    <CustomModal
      show={showModal}
      onHide={() => onHide(selectedData)}
      title="Search Content"
      modalClass="change-password search-modal-class"
    >
      <div className="input-search-drop-frame">
        <div className="dropdown-frame">
          <DropdownButton
            id="dropdown-basic-button"
            onSelect={(e) => setContentType(e)}
            className="inter-regular f-s-18 lh-24"
            title={contentType}
          >
            {contentTypeData.map((item, i) => (
              <Dropdown.Item key={i} eventKey={item.contentTypeName}>
                {item.contentTypeName}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </div>

        <div className="search-input-frame">
          <input
            type="text"
            className="input-box"
            onKeyPress={handleEnterKeyPress}
            value={serchKey}
            onChange={handleChange}
            placeholder="Search..."
          />

          {serchKey && keyDataMatch.length > 0 && showDropdown && (
            <ul className="search-key-dropdown">
              {keyDataMatch.map((item, i) => (
                <li
                  key={i}
                  onClick={() => {
                    setSerchKey(item.keyword);
                    handleSearchApiCalled();
                    setShowDropdown(false);
                  }}
                  className="inter-regular f-s-14 lh-22"
                >
                  {item.keyword}
                </li>
              ))}
            </ul>
          )}
        </div>

        {serchKey && (
          <Image
            src={cancel}
            onClick={() => setSerchKey('')}
            alt="cancel"
            className="search-icons pointer"
          />
        )}
        <Image
          src={serch}
          onClick={handleSearchApiCalled}
          alt="search-icon"
          className="search-icons"
        />
      </div>

      <h4 className="inter-medium mt-5 f-s-22 lh-29">Selected Content :</h4>
      <ul className="selected-content-box">
        {selectedData.length > 0 ? (
          selectedData.map((item, i) => (
            <li key={i}>
              <span className="inter-regular f-s-14 ellipsis lh-22">
                <Image src={item?.amcCircleImagePath} alt="img" /> {item?.title}
              </span>
              <Image
                src={cancel}
                onClick={() => removeDataHandler(item?.uuid)}
                className="search-icons pointer"
                alt="cancel"
              />
            </li>
          ))
        ) : (
          <li>
            <span className="inter-medium f-s-16 lh-22 w-100 text-center">
              Not Selected Yet...
            </span>
          </li>
        )}
      </ul>

      <h4 className="inter-medium f-s-22 lh-29">Select Content :</h4>
      <ul className="selected-content-box">
        {searchApiData.length > 0 ? (
          searchApiData.map((item, i) => {
            const isAlreadySelected = selectedData.some(
              (e) => e.uuid === item.uuid
            );
            if (isAlreadySelected) return null;

            return (
              <li key={i}>
                <span className="inter-regular ellipsis f-s-14 lh-22">
                  <Image src={item?.amcCircleImagePath} alt="img" /> {item?.title}
                </span>
                <Button
                  onClick={() => addData(item)}
                  disabled={
                    !isMultiselect && selectedData.length >= 1
                  }
                  className="primary-btn f-s-14 py-2 text-nowrap"
                >
                  + ADD
                </Button>
              </li>
            );
          })
        ) : (
          <li>
            <span className="inter-medium f-s-16 lh-22 w-100 text-center">
              Search ...
            </span>
          </li>
        )}
      </ul>

      <div className="submit-wrapper gap-20">
        <Button onClick={() => onHide(selectedData)} className="secondary-btn">
          Close
        </Button>
        <Button onClick={() => onHide(selectedData)} className="primary-btn">
          Submit
        </Button>
      </div>
    </CustomModal>
  );
}
